import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";

import { useStyles } from "../StudentCard.css";

class Address extends Component {
  render() {
    const { classes, student } = this.props;
    return (
      <div className={classes.navRoot}>
        <div className={classes.navContent}>
          <h3>Address</h3>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>VDC</b>
            <div>{student.address.vdc}</div>
          </ListItem>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>City</b>
            <div>{student.address.city}</div>
          </ListItem>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>District</b>
            <div>{student.address.district}</div>
          </ListItem>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Province</b>
            <div>{student.address.province}</div>
          </ListItem>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Nationality </b>
            <div>{student.nationality}</div>
          </ListItem>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Country</b>
            <div>{student.address.country}</div>
          </ListItem>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(Address);
